var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9885E774-6EDF-4B22-9E92-23F895C449E1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Week-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-Summary-Cards",
    transform: "translate(-386.000000, -1311.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(360.000000, 1281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-home",
    transform: "translate(24.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,14 L18,17.5 L19.0010434,17.5 C19.5527519,17.5 20,17.9491303 20,18.4989566 L20,19.5 L20.9957349,19.5 C21.5503752,19.5 22,19.9438648 22,20.5 C22,21.0522847 21.5490248,21.5 20.9957349,21.5 L6.19447708,21.5 C5.01973641,21.5 4,20.6481843 4,19.5046024 L4,13.264753 L3.90024957,13.381647 C3.54182672,13.8018274 2.91064414,13.8518917 2.49046381,13.4934688 C2.07028348,13.135046 2.02021915,12.5038634 2.378642,12.0836831 L9.59233294,3.62715054 C10.3454957,2.72335527 11.6534869,2.72213438 12.4002496,3.61835297 L19.5499745,12 L21.0039915,12 C21.5540718,12 22,12.4438648 22,13 C22,13.5522847 21.5499119,14 21.0039915,14 L18,14 L18,14 Z M16.0028203,10.9243272 L11,5.06169541 L5.99717974,10.9243272 C5.99904871,10.9493069 6,10.9745423 6,11 L6,19.5046024 L16,19.5046024 L16,11 C16,10.9745423 16.0009513,10.9493069 16.0028203,10.9243272 L16.0028203,10.9243272 Z M9,12.9990507 C9,12.4472902 9.44335318,12 9.99905068,12 L12.0009493,12 C12.5527098,12 13,12.4433532 13,12.9990507 L13,15.0009493 C13,15.5527098 12.5566468,16 12.0009493,16 L9.99905068,16 C9.44729022,16 9,15.5566468 9,15.0009493 L9,12.9990507 Z",
    id: "path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.028ffaf947724436a94fedaf7b48d506.svg";
export { ForwardRef as ReactComponent };